// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3mjvT","row":"Node_row__3OM-3","label":"Node_label__4Ea7K","footer":"Node_footer__3RIuL"};